import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import { getProductPropertiesForTracking, ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

export interface AppExclusiveMessageEventProperties {
  product: Product
  selectedOptions: ProductVariantOption[]
  isFinalSaleProduct: boolean
  isColorAppExclusive: boolean
  propertyOverrides: Partial<ProductProperties>
  action: string
}

export const getAppExclusiveMessageEventProperties = (props: AppExclusiveMessageEventProperties) => {
  const { product, selectedOptions, isFinalSaleProduct, isColorAppExclusive, propertyOverrides, action } = props
  return {
    //eslint-disable-next-line i18next/no-literal-string
    entity_type: 'action',
    action: action,
    productId: product?.spid,
    isValentineProduct: product?.isValentineProduct,
    internalProductId_color: product?.id?.toString() ?? '' + '_' + (selectedOptions?.[0]?.value?.toString() ?? ''),
    variantTitle: product?.title,
    sku: product?.variants?.[0]?.sku,
    productTitle: product?.title,
    price: product?.variants?.[0]?.price,
    productType: product?.productTypeName,
    // @i18n-ignore
    vendor: 'Quince',
    division: product?.classification?.division?.name,
    subDepartment: product?.classification?.subDepartment?.name,
    department: product?.classification?.department?.name,
    class: product?.classification?.class?.name,
    subClass: product?.classification?.subClass?.name,
    gender: product?.gender,
    internal_product_id: product?.id,
    slug: product?.slug,
    context: {
      is_final_sale: isFinalSaleProduct ? 1 : 0,
      is_app_exclusive: isColorAppExclusive ? 1 : 0,
      productProperties: getProductPropertiesForTracking(product ?? ({} as Product), '', propertyOverrides),
    },
  }
}
